import React, { Component, Fragment } from "react";
import queryString from "query-string";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as StoresActions } from "store/ducks/stores";

import { Access } from "common";
import { Page, Panel, Loading, Pagination, Breadcrumbs } from "components";

class List extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Pontos", to: "/points" },
      { name: "Lojas", to: "" },
    ],
  };

  componentDidMount() {
    const { location, getStoresRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getStoresRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getStoresRequest } = this.props;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      getStoresRequest(queryString.parse(location.search).page);
    }
  }

  render() {
    const { breadcrumbs } = this.state;
    const { stores } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Lojas</Page.Title>

        <Panel className="panel-list">
          {!stores.data.length && stores.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {stores.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>código</th>
                    <th className="big-size-80">nome</th>
                    <th>percentual ead</th>
                    <th>presencial docs</th>
                    <th>ativa</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!stores.data.length && (
                    <tr>
                      <td colSpan="4" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {stores.data.map((store, index) => (
                    <tr key={store.id}>
                      <td>{store.attributes.external_store_id}</td>
                      <td>{store.attributes.name}</td>
                      <td>{store.attributes.percentage_ead || 0}%</td>
                      <td
                        className={
                          store.attributes.presential_docs
                            ? "label-active"
                            : "label-inactive"
                        }
                      >
                        {store.attributes.presential_docs ? "Sim" : "Não"}
                      </td>
                      <td
                        className={
                          store.attributes.score
                            ? "label-active"
                            : "label-inactive"
                        }
                      >
                        {store.attributes.score ? "Sim" : "Não"}
                      </td>
                      <td className="text-right">
                        {Access.hasPermissions("edit-places") && (
                          <Link
                            to={`/points/stores/${store.id}/edit`}
                            className="button-icon"
                          >
                            <span className="glyph glyph-pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="4" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={stores.page}
                total={stores.totals}
                {...this.props}
              />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  stores: state.stores,
});

const mapActions = (dispatch) => bindActionCreators(StoresActions, dispatch);

export default connect(mapState, mapActions)(List);
